import { TemplateElement, html, defineElement, when } from '@webtides/element-js';
import style from './comparison-cards.css';
import '../../../comparison-card/comparison-card.js';
import '../../../slider/slider.js';

/**
 * @typedef {Object} ComparisonCardProperties
 * @property {string} highlightText
 * @property {string} headline
 * @property {string} text
 * @property {string[]} benefits
 * @property {string[]} facts
 * @property {object} link
 */

/**
 * @property {string} headline
 * @property {ComparisonCardProperties[]} cards
 * @property {LinkProperties} link
 * @property {text} legalText
 */
export default class ComparisonCards extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            headline: '',
            cards: [],
            link: undefined,
            legalText: '',
        };
    }

    template() {
        return html`
            <div class="flex flex-col gap-40">
                ${when(
                    this.headline,
                    html` <h2 class="text-2xl md:text-3xl mb-0 sm:text-center">${this.headline}</h2> `,
                )}
                <mb-slider swiper-options="${JSON.stringify({ centerInsufficientSlides: true })}">
                    ${this.cards.map(
                        (card, index) => html`
                            <mb-comparison-card
                                slot="slide-${index}"
                                class="h-full"
                                highlight-text="${card.highlightText}"
                                headline="${card.headline}"
                                text="${card.text}"
                                benefits-label="${card.benefitsLabel}"
                                .benefits="${card.benefits}"
                                .facts="${card.facts}"
                                .link="${card.link}"
                            ></mb-comparison-card>
                        `,
                    )}
                </mb-slider>
                ${when(
                    this.link?.url && this.link?.text,
                    html` <a
                        href="${this.link?.url}"
                        class="Button btn btn-outline-primary sm:self-center"
                        element="comparison cards"
                    >
                        ${this.link?.text}
                    </a>`,
                )}
                ${when(this.legalText, html` <div class="LegalText text-center"><p>${this.legalText}</p></div>`)}
            </div>
        `;
    }
}

defineElement('mb-comparison-cards', ComparisonCards);
